/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2024, Zumper
 * @description  formatLeaseLength
 */

export const formatLeaseLength = (
  leaseLength: string[],
  leaseLengthMap: { [key: string]: string }
) => {
  return (leaseLength || []).reduce(
    (accumulator: { [key: string]: boolean }, value: string) => {
      accumulator[leaseLengthMap[value]] = true
      return accumulator
    },
    {
      monthly: false,
      vacation: false,
      long_term: false,
    }
  )
}
